module.exports = __webpack_public_path__ + "img/defaultAvatar.bb56d1c2.png";